/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleInHexagon: {
  name: 'circle-in-hexagon';
  data: string;
} = {
  name: 'circle-in-hexagon',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.67.776a1.5 1.5 0 0 0-1.34 0l-5 2.5a1.5 1.5 0 0 0-.83 1.342v6.764a1.5 1.5 0 0 0 .83 1.342l5 2.5a1.5 1.5 0 0 0 1.34 0l5-2.5a1.5 1.5 0 0 0 .83-1.342V4.618a1.5 1.5 0 0 0-.83-1.342l-5-2.5ZM12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" fill="currentColor"/></svg>`,
};
